var Processor = require('./processor');

exports.Processor = Processor;
